import React from 'react';
import Utils from 'utils';
import DecimalPointer from 'components/canvas/DecimalPointer';
import DigitRect from 'components/canvas/DigitRect';
import ImageData from 'components/ImageData';

require('style/GaugeCanvas');

export default class GaugeCanvas extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      moveAll: false,
      moveAllUpdate: false,
    };
  }

  componentDidMount() {
    this.resolvePositions();
    this.updateCanvas();
    this.onMouseUpBind = this.onMouseUp.bind(this);
    window.addEventListener('mouseup', this.onMouseUpBind);
    this.onKeyDownBind = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.onKeyDownBind);
    this.onKeyUpBind = this.onKeyUp.bind(this);
    window.addEventListener('keyup', this.onKeyUpBind);
    let canvas = this.refs.canvas;
    if (canvas && this.props.image.digits && this.props.image.debugData) {
      this.drawDebugDigits(this.props.image.debugData, canvas.width, this.props.image.digits.digits)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.onMouseUpBind);
    window.removeEventListener('keydown', this.onKeyDownBind);
  }

  componentWillReceiveProps(props) {
    this.resolvePositions(props);
  }

  componentDidUpdate(prevProps) {
    if (this.state.moveAllUpdate) {
      this.resolvePositions(this.props);
      this.setState({moveAllUpdate: false});
    }
    this.updateCanvas();
    if (!prevProps.image && this.props.image) {
      let canvas = this.refs.canvas;
      if (canvas && this.props.image.digits && this.props.image.debugData) {
        this.drawDebugDigits(this.props.image.debugData, canvas.width, this.props.image.digits.digits)
      }
    }
  }

  resolvePositions(props) {
    props = props || this.props;
    if (props.image && props.settings) {
      const image = props.image;
      const settings = props.settings;
      let objects = [];

      // Decimal pointers
      if (this.state.moveAll || props.pointerEdit) {
        let useCoords = settings.decimals.useCoords;
        if (settings.decimals.positions && useCoords) {
          objects = objects.concat(settings.decimals.positions.map((pos, idx) => {
            if (pos.coords) {
              if (pos.itronMode) {
                let coords = pos.coords || [
                  50 + idx * 40, 50,
                  80 + idx * 40, 80
                ];
                return new DigitRect(idx, false, coords, pos.precision);
              }
              return new DecimalPointer(idx, false, pos.coords.x, pos.coords.y, pos.precision);
            } else {
              let center = {x: 50 + 50 * idx, y: 100};
              if (image.meters && image.meters[idx]) {
                center = image.meters[idx].center;
              }
              return new DecimalPointer(idx, false, center.x, center.y, pos.precision);
            }
          }));
        } else if (image.meters) {
          objects = objects.concat(
            image.meters.map((meter, index) => new DecimalPointer(
              index,
              true,
              meter.center.x,
              meter.center.y,
              settings.decimals.positions[index]
                ? settings.decimals.positions[index].precision
                : '???'
            ))
          );
        }
      }

      // Digit rects

      if (this.state.moveAll || props.digitEdit) {
        if (settings.digits.positions) {
          objects = objects.concat(settings.digits.positions.map((pos, idx) => {
            let coords = pos.coords || [
              50 + idx * 40, 50,
              80 + idx * 40, 80
            ];
            return new DigitRect(idx, false, coords, pos.precision);
          }));
        }
      }

      // Set active flag back
      if (this.activeObj) {
        let activeObj = Utils.findFirstObject(objects, (obj) => obj.findObject(this.activeObj.id));
        if (activeObj) {
          activeObj.setActive(true);
        }
        this.activeObj = activeObj;
      }

      this.setState({objects});
    }
  }

  onMouseDown(evt) {
    const {x, y} = Utils.getEventXY(evt, this.refs.canvas);
    this.state.objects.forEach((obj) => obj.active = false);

    let hitObj = Utils.findFirstObject(this.state.objects, (obj) => obj.testHit(x, y));
    if (hitObj) {
      hitObj.startDrag(x, y);
      this.dragObj = hitObj;
      if (this.activeObj) {
        this.activeObj.setActive(false);
      }
      this.activeObj = hitObj;
      this.activeObj.setActive(true);
      this.setState({moving: true});
    } else {
      if (this.activeObj) {
        this.activeObj.setActive(false);
        this.activeObj = null;
      }
    }
    this.updateCanvas();
    this.updateZoomCanvas(x, y);
  }

  onMouseMove(evt) {
    const {x, y} = Utils.getEventXY(evt, this.refs.canvas);
    if (this.dragObj) {
      this.dragObj.drag(x, y);
      this.updateCanvas();
    } else {
      this.setState({
        hover: this.state.objects.find((obj) => obj.testHit(x, y))
      });
    }
    this.updateZoomCanvas(x, y);
  }

  onMouseUp(evt) {
    if (this.dragObj) {
      this.dragObj.endDrag();
      this.dragObj = null;
      this.emitPositions();
    }
    this.setState({moving: false});
  }

  onKeyDown(evt) {
    if (this.activeObj) {
      let targets = [];
      let objType = this.activeObj.constructor.name;
      if (evt.ctrlKey && !evt.shiftKey) {
        // active object is DigitRect or DecimalPointer
        if (objType === 'DigitRect' || objType === 'DecimalPointer') {
          targets = this.state.objects.filter((obj) => obj.constructor.name === objType);
        } else {
          // active object is DigitRectHandle
          this.state.objects.forEach((obj) => {
            if (obj.objects) {
              obj.objects.forEach((child) => {
                if (this.activeObj.id.includes('.tl') && child.id.includes('.tl')) {
                  targets.push(child);
                } else if (this.activeObj.id.includes('.br') && child.id.includes('.br')) {
                  targets.push(child);
                }
              });
            }
          });
        }
      } else if (evt.ctrlKey && evt.shiftKey) {
        if (objType === 'DigitRect' || objType === 'DecimalPointer') {
          targets = this.state.objects.filter((obj) => obj.constructor.name === 'DigitRect' || obj.constructor.name === 'DecimalPointer');
          if (!this.state.moveAll) {
            this.setState({moveAll: true, moveAllUpdate: true});
          }
        }
      } else {
        targets = [this.activeObj];
      }
      switch (evt.which) {
        case 37: targets.forEach((obj) => obj.move(-1, 0)); break; // left
        case 38: targets.forEach((obj) => obj.move(0, -1)); break; // up
        case 39: targets.forEach((obj) => obj.move(1, 0)); break; // right
        case 40: targets.forEach((obj) => obj.move(0, 1)); break; // down
        default: return;
      }
      evt.preventDefault();
      this.updateCanvas();
      let pos = this.activeObj.getPos();
      this.updateZoomCanvas(pos.x, pos.y);
      this.emitPositions();
    }
  }

  onKeyUp(evt) {
    if (this.state.moveAll) {
      if (!(evt.ctrlKey && evt.shiftKey)) {
        this.setState({moveAll: false, moveAllUpdate: true});
      }
    }
  }

  emitPositions() {
    if (this.props.onChange) {
      let coords = {};
      if (this.state.moveAll || this.props.pointerEdit) {
        //coords.decimals=this.state.objects.filter((obj) => obj instanceof DecimalPointer).map((obj) => obj.export());
        coords.decimals=this.state.objects.map((obj)=>obj.export());
      }
      if (this.state.moveAll || this.props.digitEdit) {
        coords.digits = this.state.objects.filter((obj) => obj instanceof DigitRect).map((obj) => obj.export());
      }
      this.props.onChange(coords);
    }
  }

  updateCanvas() {
    let canvas = this.refs.canvas;
    if (canvas) {
      const srcCanvas = this.props.image.canvas;
      canvas.width = srcCanvas.width;
      canvas.height = srcCanvas.height;
      let ctx = canvas.getContext('2d');

      // Draw image
      ctx.drawImage(srcCanvas, 0, 0);

      // Draw objects
      this.state.objects.forEach((obj) => obj.render(ctx));
      
    }
  }

  updateZoomCanvas(x, y) {
    const zoomFactor = 3;
    let srcCanvas = this.refs.canvas;
    let trgCanvas = this.refs.zoom;
    if (srcCanvas && trgCanvas) {
      let trgW = trgCanvas.width;
      let trgH = trgCanvas.height;
      let srcW = trgW / zoomFactor;
      let srcH = trgH / zoomFactor;

      let ctx = trgCanvas.getContext('2d');
      ctx.save();
      ctx.clearRect(0, 0, trgW, trgH);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(
        srcCanvas,
        x - srcW / 2, y - srcH / 2, srcW, srcH,
        0, 0, trgW, trgH
      );
      ctx.restore();
    }
  }

  drawDebugDigits(src, width, digitParams) {
    let zoomFactor = 3;
    let posX = 0, posY = 26, CH = 4, labelY2 = 0;
    // can we display all digits with current zoom
    if (zoomFactor * digitParams.length * (digitParams[0].coords[2] - digitParams[0].coords[0]) > 550) {
      zoomFactor = 2;
    }
    for (let i = 0; i < digitParams.length; i++) {
      let digitCoords = digitParams[i].coords;
      let labelX = posX + ((digitCoords[2] - digitCoords[0]) / 2) * zoomFactor;
      let labelY = posY + (digitCoords[3] - digitCoords[1]) * zoomFactor + 5;
      this.drawDebugDigit(src, digitCoords, width, CH, posX, posY, zoomFactor, digitParams[i].precision, labelX, labelY, labelY2, digitParams[i].result, digitParams[i].inverted);
      posX = posX + (digitCoords[2] - digitCoords[0]) * zoomFactor + 1; 
    }
  }

  drawDebugDigit(src, imgArea, W, CH, posX, posY, zoomFactor, label, labelX, labelY, labelY2, result, inverted) {
    let trgCanvas = this.refs.debug;
    let context = trgCanvas.getContext('2d');
    context.font = "12px Arial";
    context.fillStyle = 'black';
    context.textBaseline = 'top';
    context.textAlign = 'center';
    // precision
    context.fillText(label, labelX, labelY);
    context.font = "24px Arial";
    // result
    context.fillStyle = (result < 0) ? "#b30909" : "#5bb309";
    context.fillText(result, labelX, labelY2);
		var xEnd = imgArea[2];
		var yEnd = imgArea[3];
		for (var y = imgArea[1]; y <= yEnd; y++){ // lines
			for (var x = imgArea[0], i; x < xEnd; x++){ // rows
				i = x * CH + y * CH * W; // Position to index
				context.fillStyle = inverted ? "darkgray" : "black";
				if (src[i] == 255) {
          context.fillStyle = (result < 0) ? "#f80d0d" : "#7ff80d";
        }
				context.fillRect((x - imgArea[0]) * zoomFactor + posX, (y - imgArea[1]) * zoomFactor + posY , zoomFactor, zoomFactor);
			}
		}
  }

  copySizeToOthers() {
    if (this.activeObj) {
      const size = this.activeObj.size();
      this.setState({
        objects: this.state.objects.map((obj) => {
          obj.setSize(size);
          return obj;
        })
      });
    }
  }

  interpolateDigits(interpolatePos, interpolateSizes) {
    const digits = this.state.objects
      .filter(obj => obj instanceof DigitRect)
      .sort((a, b) => a.label - b.label);

    if (digits.length > 0) {
      const lastIdx = digits.length - 1;
      const posA = digits[0].pos();
      const posB = digits[lastIdx].pos();
      const sizeA = digits[0].size();
      const sizeB = digits[lastIdx].size();

      const objects = this.state.objects.map(obj => {
        const index = digits.findIndex(x => x === obj);
        const t = index / lastIdx;
        if (index >= 0) {
          if (interpolatePos) {
            obj.setPos({
              x: Math.round(posA.x + (posB.x - posA.x) * t),
              y: Math.round(posA.y + (posB.y - posA.y) * t)
            });
          }
          if (interpolateSizes) {
            obj.setSize({
              width:  Math.round(sizeA.width + (sizeB.width - sizeA.width) * t),
              height: Math.round(sizeA.height + (sizeB.height - sizeA.height) * t)
            });
          }
        }
        return obj;
      });
      this.setState({objects});
    }
  }

  render() {
    if (this.props.message || !this.props.image) {
      return (
        <div className="GaugeCanvas">
          <div className="loader">{this.props.message || 'No image'}</div>
        </div>
      );
    }

    let image = this.props.image;
    let classes = ["GaugeCanvas"];
    if (this.state.hover) {
      classes.push('handle-hover');
    }
    if (this.state.moving) {
      classes.push('moving-object');
    }

    return (
      <div className={classes.join(' ')}>
        <div>
          <canvas
            ref="canvas"
            onMouseDown={this.onMouseDown.bind(this)}
            onMouseMove={this.onMouseMove.bind(this)}
          />
          {
            this.props.digitEdit &&
            <div className="button-group">
              {this.activeObj instanceof DigitRect && <button onClick={this.copySizeToOthers.bind(this)}>Copy size to others</button>}
              <button onClick={() => this.props.autoConfigButton()}>Auto config</button> 
              <button onClick={() => this.interpolateDigits(true, false)}>Distribute digits</button>
              <button onClick={() => this.interpolateDigits(false, true)}>Interpolate sizes</button>
              <button onClick={() => this.props.scaleUpButton()}>Prec +</button> 
              <button onClick={() => this.props.scaleDownButton()}>Prec -</button> 
              <button onClick={() => this.props.addLeftButton()}>Add left</button> 
              <button onClick={() => this.props.addRightButton()}>Add right</button> 
            </div>
          }
        </div>
        <ImageData {...image} tab={this.props.tab}>
          <canvas ref="zoom" width={300} height={300} />
          <canvas ref="debug" width={600} height={220} />
        </ImageData>
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./client/components/GaugeCanvas.js